import React from "react"
import { useTranslation } from "react-i18next"

import { EMPTY_DATA_PLACEHOLDER } from "@/utils/constants"

import Chip from "@mui/material/Chip"

type MeterStatus = "ACTIVE" | "DECOMMISSIONED"

const meterStatusConfig: Record<
  MeterStatus,
  { bgcolor: string; labelKey: string }
> = {
  ACTIVE: { bgcolor: "spectrum.green.300", labelKey: "meterStatus.active" },
  DECOMMISSIONED: { bgcolor: "grey.300", labelKey: "meterStatus.inactive" },
}

interface MeterStatusChipProps {
  meterStatus: string | null | undefined
}

export const MeterStatusChip: React.FC<MeterStatusChipProps> = ({
  meterStatus,
}) => {
  const { t } = useTranslation("common")
  const config =
    meterStatus === "ACTIVE" || meterStatus === "DECOMMISSIONED"
      ? meterStatusConfig[meterStatus]
      : null

  if (!config) {
    return EMPTY_DATA_PLACEHOLDER
  }

  return (
    <Chip
      component="span"
      label={t(config.labelKey)}
      size="small"
      sx={{
        bgcolor: config.bgcolor,
        color: "common.white",
        fontWeight: "bold",
      }}
      variant="filled"
    />
  )
}
